<template>
  <div id="event-info">
    <div class="ql-editor ql-container ql-snow" style="margin-bottom:2rem;" v-html="currentEvent.about"></div>

    <div>
      <h3 style="margin: 0" v-if="currentEvent.location != null && currentEvent.location.venue != '' && currentEvent.location.venue != null">
        {{ currentEvent.location.venue }}
      </h3>
      <p style="margin: 0; margin-bottom: 10px;" v-if="currentEvent.location != null && currentEvent.location.address != null && currentEvent.location.address != ''">
        {{ currentEvent.location.address }}
      </p>
    </div>

    <div v-if="currentEvent.location != null && currentEvent.location.longtitude != null && currentEvent.location.longtitude != ''">
      <GmapMap
        :center="{
          lat: parseFloat(currentEvent.location.latitude),
          lng: parseFloat(currentEvent.location.longtitude)
        }"
        :options="{
          zoomControl: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: true,
          disableDefaultUI: false,
          draggable: false
        }"
        :zoom="14"
        map-type-id="terrain"
        style="position: relative; height: 200px; border-radius: 8px; overflow: hidden; border: 0.5px solid #D6D9D9;"
      >
        <GmapMarker
          :draggable="false"
          :clickable="false"
          :position="{
            lat: parseFloat(currentEvent.location.latitude),
            lng: parseFloat(currentEvent.location.longtitude)
          }"
        />
      </GmapMap>
    </div>
    <div class="buttons-area" v-if="currentEvent.organizator != null">
      <div class="left">
        <a class="contact-area" v-if="currentEvent.organizator.phoneNumberIsActive && currentEvent.organizator.phoneNumber != null" :href="'tel:' + currentEvent.organizator.phoneNumber">
          <i class="fas fa-phone-alt"></i>
        </a>
        <a class="cellPhone" v-if="currentEvent.organizator.mobilePhoneIsActive && currentEvent.organizator.mobilePhone != null" :href="'tel:' + currentEvent.organizator.mobilePhone">
          <i class="fas fa-mobile"></i>
        </a>
        <a class="mail" v-if="currentEvent.organizator.emailIsActive && currentEvent.organizator.email != null" :href="'tel:' + currentEvent.organizator.email">
          <i class="fas fa-envelope"></i>
        </a>
      </div>
      <div class="right" v-if="currentEvent.location.longtitude != null && currentEvent.location.longtitude != ''">
        <el-button size="mini" icon="fas fa-map-marker-alt" type="primary" @click="googleMaps(currentEvent.location.latitude, currentEvent.location.longtitude)" round>{{ $t("directions") }}</el-button>
      </div>
    </div>

    <div class="social-bar-home" v-if="currentEvent.socialMedia != null">
      <div class="social-icon twitter" v-if="currentEvent.socialMedia.twitterIsACtive">
        <a :href="currentEvent.socialMedia.twitter" target="_blank">
          <i class="fab fa-twitter"></i>
        </a>
      </div>

      <div class="social-icon linkedIn" v-if="currentEvent.socialMedia.linkedInIsActive">
        <a :href="currentEvent.socialMedia.linkedIn" target="_blank">
          <i class="fab fa-linkedin"></i>
        </a>
      </div>

      <div class="social-icon facebook" v-if="currentEvent.socialMedia.facebookIsActive">
        <a :href="currentEvent.socialMedia.facebook" target="_blank">
          <i class="fab fa-facebook"></i>
        </a>
      </div>

      <div class="social-icon instagram" v-if="currentEvent.socialMedia.instagramIsActive">
        <a :href="currentEvent.socialMedia.instagram" target="_blank">
          <i class="fab fa-instagram"></i>
        </a>
      </div>

      <div class="social-icon youtube" v-if="currentEvent.socialMedia.youtubeIsActive">
        <a :href="currentEvent.socialMedia.youtube" target="_blank">
          <i class="fab fa-youtube"></i>
        </a>
      </div>

      <div class="social-icon website" v-if="currentEvent.socialMedia.websiteIsActive">
        <a :href="currentEvent.socialMedia.website" target="_blank">
          <i class="fas fa-globe"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EventInfo",
  mounted() {},
  data() {
    return {};
  },
  methods: {
    googleMaps(lat, long) {
      var latitude = parseFloat(lat);
      var longtitude = parseFloat(long);
      window.open(`https://www.google.com/maps/search/?api=1&query=${latitude},${longtitude}`, "_blank");
    }
  },
  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    }
  }
};
</script>
<style scoped lang="less">
#event-info {
  .buttons-area {
    & > .left {
      display: flex;
      gap: 10px;
      flex-direction: row;
      & > a {
        width: 28px;
        background: #268ea6;
        border-radius: 28px;
        color: white;
        text-decoration: none;
        user-select: none;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        height: 28px;
      }
      & > .right {
        width: auto;
        & > .el-button {
          min-height: 40px;
          padding: 10px 24px;
          font-weight: bold !important;
        }
      }
    }
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 1rem;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/event/EventInfo.vue